import { Autocomplete, AutocompleteProps, TextField } from '@mui/material'
import { FormTopLabel } from './forms/FormTopLabel'
import React, { ReactElement } from 'react'

interface AutocompleteFieldWrapperProps<
  T,
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = false,
  FreeSolo extends boolean | undefined = false
> extends AutocompleteProps<T, Multiple, DisableClearable, FreeSolo> {
  label?: string | ReactElement
  isTopLabel?: boolean
}

export function CustomAutocomplete<
  T,
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = false,
  FreeSolo extends boolean | undefined = false
> ({
  label,
  isTopLabel,
  ...props
}: AutocompleteFieldWrapperProps<T, Multiple, DisableClearable, FreeSolo>): JSX.Element {
  return (
    <>
      {isTopLabel === true && label != null && (
        <FormTopLabel>{label}</FormTopLabel>
      )}
      <Autocomplete
        {...props}
        renderInput={(params) =>
          <TextField
            label={isTopLabel === true ? undefined : label}
            variant='outlined'
            {...params}
          />}
      />
    </>
  )
}
